var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-block home-block7" }, [
    _c("div", { staticClass: "text", attrs: { "data-aos": "fade-up" } }, [
      _vm._v(" " + _vm._s(_vm.$t("home.block7.text")) + " "),
    ]),
    _c("div", {
      ref: "block-7-lottie",
      staticClass: "lottie",
      attrs: { id: "home-block-7-lottie" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }